import { render, staticRenderFns } from "./InformationOnVoucher.vue?vue&type=template&id=19b89876"
import script from "./InformationOnVoucher.vue?vue&type=script&lang=js"
export * from "./InformationOnVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19b89876')) {
      api.createRecord('19b89876', component.options)
    } else {
      api.reload('19b89876', component.options)
    }
    module.hot.accept("./InformationOnVoucher.vue?vue&type=template&id=19b89876", function () {
      api.rerender('19b89876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/productContent/tickets/InformationOnVoucher.vue"
export default component.exports